"use client";

import { useEffect } from "react";
import { getToken } from "@/lib/auth";
import { setSentryAnonymousUser } from "@/lib/sentry-user";

/**
 * Ensures Sentry has a user identity on every page for Release Health (Crash Free Users).
 * Sets anonymous ID when no auth token. HeaderAuth sets the real user when profile loads.
 */
export function SentryUserSync() {
  useEffect(() => {
    if (!getToken()) {
      setSentryAnonymousUser();
    }
  }, []);
  return null;
}
